import {Clock} from 'lucide-react';


const TimerExamComponent = ({ timeRemaining }) => {
    const minutes = Math.floor(timeRemaining / 60);
    const seconds = timeRemaining % 60;
    const isUrgent = timeRemaining <= 60;

    return (
        <div
            className={`flex items-center gap-3 px-6 py-4 rounded-2xl transition-all ${
                isUrgent
                    ? 'bg-red-500 shadow-lg shadow-red-500/50 animate-pulse'
                    : 'bg-green-300 shadow-xl'
            }`}
        >
            <Clock className={`w-6 h-6 text-black ${isUrgent ? 'animate-bounce' : ''}`} />
            <div className="text-left">
                <p className="text-xs opacity-90 mb-1 text-black">زمان باقی‌مانده</p>
                <p className="text-3xl font-bold text-black">
                    {String(minutes).padStart(2, '0')}:{String(seconds).padStart(2, '0')}
                </p>
            </div>
        </div>
    );
};

export default TimerExamComponent;
